import { Col, Tappable, Text, useTheme } from "@rally/ui-kit";
import type { RecordedMessage } from "../../net/api.ts";
import { useStack } from "../panel/panels.tsx";
import { TargetActions } from "../target-actions.tsx";
import { appCard, type ListedApp } from "./app-resource.tsx";

export function InlineApps({
  apps,
  onChanged,
  onReply,
}: {
  apps: RecordedMessage["apps"];
  onChanged: () => void;
  onReply: (target: string, said: string) => void;
}) {
  const theme = useTheme();
  const stack = useStack();
  if (apps.length === 0) return null;
  return (
    <Col style={{ gap: theme.space[2] }} testID="inline-apps">
      {apps.map((app) => {
        const listed: ListedApp = {
          ...app,
          slug: app.id,
          channel: null,
          display: {},
          config: {},
          hostingMode: null,
          healthStatus: null,
        };
        return (
          <Col key={app.target} style={{ gap: theme.space[1] }} testID={`inline-app-${app.target}`}>
            <Tappable
              accessibilityRole="button"
              accessibilityLabel={app.name}
              onPress={() => stack.open(appCard(listed))}
              style={{
                minHeight: 64,
                justifyContent: "center",
                padding: theme.space[3],
                borderWidth: 1,
                borderColor: theme.color["border.default"],
                borderRadius: theme.radius.md,
              }}
            >
              <Text typeName="bodySemibold" color="text.primary">
                {app.name}
              </Text>
              {app.description ? (
                <Text typeName="caption" color="text.secondary">
                  {app.description}
                </Text>
              ) : null}
            </Tappable>
            <TargetActions
              target={{ kind: "app", id: app.target }}
              reactions={app.reactions}
              away={app.away}
              capabilities={app.capabilities}
              onChanged={onChanged}
              onReply={() => onReply(app.target, app.name)}
              testID={`actions-app-${app.target}`}
              revealed
            />
          </Col>
        );
      })}
    </Col>
  );
}
